var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H14.5003L11.8997 4.05C11.6397 3.85599 11.3241 3.7508 10.9997 3.75H6.75C6.35218 3.75 5.97064 3.90804 5.68934 4.18934C5.40804 4.47064 5.25 4.85218 5.25 5.25V6.75H3.75C3.35218 6.75 2.97064 6.90804 2.68934 7.18934C2.40804 7.47064 2.25 7.85218 2.25 8.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H18.0834C18.459 20.2495 18.819 20.1001 19.0846 19.8346C19.3501 19.569 19.4995 19.209 19.5 18.8334V17.25H21.0834C21.459 17.2495 21.819 17.1001 22.0846 16.8346C22.3501 16.569 22.4995 16.209 22.5 15.8334V7.5C22.5 7.10218 22.342 6.72064 22.0607 6.43934C21.7794 6.15804 21.3978 6 21 6ZM21 15.75H19.5V10.5C19.5 10.1022 19.342 9.72064 19.0607 9.43934C18.7794 9.15804 18.3978 9 18 9H11.5003L8.89969 7.05C8.63967 6.85599 8.32411 6.7508 7.99969 6.75H6.75V5.25H10.9997L13.8 7.35C13.9298 7.44737 14.0877 7.5 14.25 7.5H21V15.75Z",
    stroke: "#1E1147",
    strokeWidth: 1.5,
    strokeOpacity: 0.24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTickets);
export default __webpack_public_path__ + "static/media/all-tickets.1eeb536ec4062b2bb12e52ee6c3aa18e.svg";
export { ForwardRef as ReactComponent };